<template>
<div class="wrap">
    <div class="subPage-pc-menu">
        <ul>
            <li :class="{'active': ($route.path.indexOf(pItem.subLink) !== -1) && ($route.query.name.indexOf(pItem.subName) !== -1)}"  v-for="(pItem,pIdx) in pcSubPageMenu" :key="pIdx" @click="tabMenu(pItem)">{{pItem.subName}}</li>
        </ul>
    </div>
    <div class="swiper-container subPage-mobile-menu">
        <div class="swiper-wrapper">
            <div class="swiper-slide" :class="{'active': ($route.path.indexOf(pItem.subLink) !== -1) && ($route.query.name.indexOf(pItem.subName) !== -1)}"  v-for="(pItem,pIdx) in pcSubPageMenu" :key="pIdx" @click="tabMenu(pItem)">
                {{pItem.subName}}
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
// var newsSwiper;
export default {
    name: 'menubar',
    data () {
        return {}
    },
    props: {
        pcSubPageMenu: Array,
    },
    mounted() {
        this.slideTo();
    },
    methods:{
        tabMenu(pItem){
            this.$emit('subpagemenu',pItem)
        },
        slideTo(){
            this.$nextTick(function () {
                var newsSwiper = new Swiper ('.subPage-mobile-menu', {
                    slidesPerView:  3.7,
                    grabCursor : true,
                    freeMode : true,
                    slideToClickedSlide: true,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                })
                this.pcSubPageMenu.map((item,idx)=>{
                    if(this.$route.path.indexOf(item.subLink) !== -1 && (this.$route.query.name.indexOf(item.subName) !== -1)){
                        newsSwiper.slideTo(idx, 1000, false);
                    }
                })
            });
        }
    },
}
</script>
<style lang="less" scoped>
@import "../../../static/function.less";
.subPage-pc-menu{
    // background-color: #e1e1e1;
    // border: 1px solid #e4e4e4;
    li{
        font-size: @font16;
        color: #666;
        font-weight: bold;
        padding: 10px 40px 10px 30px;
        font-size: @font14;
        border: 1px solid #e4e4e4;
        margin:0px 0px -1px -1px;
        cursor: pointer;
        position: relative; 
        z-index: 0;
        &:hover{
            color: @colorff4e4e;
        }
        &.active{
            color: #fff;
            background-color: @colorff4e4e;
            border: 1px solid @colorff4e4e;
            z-index: 1;
            &::after{
                content: "";
                position: absolute;
                width: 42px;
                height: 42px;
                background: #2d9bf0 url("../../../static/images/right.png") no-repeat center;
                top: -1px;
                right: -1px;
            }
        }
        
        &:last-chlid{
            border-bottom: none;
        }
    }
}
.subPage-mobile-menu{
    display: none;
    span{}
    border: 1px solid #e4e4e4;
    min-height: 40px;
    .swiper-slide{
        position: relative;
        font-size: @font14;
        padding: 8px 5px;
        text-align: center;
        .flexcontentitems(center,center);
        height: auto;
        &.active{
            color:#ea0e1e;
            border-bottom: 3px solid;
        }
        &:after{
            content: '|';
            position: absolute;
            right: -7%;
            top: 50%;
            transform:translate(-50%,-50%);
            font-size: 20px;
            color: #e4e4e4;
        }
    }
}
@media (min-width: 320px) and (max-width: 767px){
    .subPage-pc-menu{
        display: none;
    }
    .subPage-mobile-menu{
        display: block;
    }
    .wrap{
        margin-top: 0px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/subMenuBar/subMenuBar.vue